
import { useState, useEffect } from 'react';

export function useUrlParams() {
  // 1. Initialize state with the current value
  const [value, setValue] = useState(
    new URLSearchParams(window.location.search)
  );

  useEffect(() => {
    // 2. Define a function to update state when the URL changes
    const onChange = () => {
      const params = new URLSearchParams(window.location.search);
      setValue(params);
    };

    // 3. Listen for browser navigation (Back/Forward buttons)
    window.addEventListener('popstate', onChange);

    // 4. Cleanup listener when component unmounts
    return () => window.removeEventListener('popstate', onChange);
  }, []);

  return value;
}